import {
  redirect,
  LoaderFunction,
  LoaderFunctionArgs,
  useLocation,
} from "react-router-dom";
import { userStore } from "../../store/user";
import { PERMISSIONS } from "./api";

const { getState } = userStore;

export const requireAuth = (
  requiredPermissions?: PERMISSIONS[],
  loader?: LoaderFunction
) => {
  return async (args: LoaderFunctionArgs) => {
    const user = getState().user;

    const permissions = getState().permissions as PERMISSIONS;
    // const currentPath = new URL(args.request.url);
    // const fullPath = currentPath.pathname;

    if (!user) {
      return redirect("/login");
    }

    if (
      permissions &&
      requiredPermissions &&
      !requiredPermissions.includes(permissions)
    ) {
      return redirect("/login");
    }
    return loader?.(args) || {};
  };
};

// Gates a route to true Ronin admins by checking the actual user role.
// Unlike requireAuth([PERMISSIONS.ADMIN]), this is not satisfied by the
// "admin" permissions value that every admin-app login receives.
export const requireRoninAdmin = (loader?: LoaderFunction) => {
  return async (args: LoaderFunctionArgs) => {
    const user = getState().user;
    if (!user) {
      return redirect("/login");
    }
    if (user.role_id !== 1) {
      return redirect("/");
    }
    return loader?.(args) ?? null;
  };
};
